import { ISearchParams } from './search-data.data';
import { GlobalSearch } from './global-search.model';
import { DocumentsSearch } from './document-search.model';
import { RecentDocumentsSearch } from './recent-documents-search.model';

// action interfaces
export interface ISearchDataPayload {
  params: ISearchParams;
}

export interface ISearchGloballyPayload {
  globalSearch: GlobalSearch;
}

export interface ISearchDocumentsPayload {
  documentsSearch: DocumentsSearch;
}

export interface IRecentDocumentsPayload {
  recentDocuments: RecentDocumentsSearch;
}

export interface IRegisterRecentDocumentsPolling {
  pageSize: number;
  interval: number;
}

export interface ISearchDataErrorPayload {
  error: any[];
}

// action enums
export enum ActionsEnum {
  SEARCH_GLOBALLY = 'SEARCH_GLOBALLY',
  SEARCH_GLOBALLY_SUCCESS = 'SEARCH_GLOBALLY_SUCCESS',
  SEARCH_GLOBALLY_ERROR = 'SEARCH_GLOBALLY_ERROR',
  CLEAR_GLOBAL_SEARCH = 'CLEAR_GLOBAL_SEARCH',
  SEARCH_DOCUMENTS = 'SEARCH_DOCUMENTS',
  SEARCH_DOCUMENTS_SUCCESS = 'SEARCH_DOCUMENTS_SUCCESS',
  SEARCH_DOCUMENTS_ERROR = 'SEARCH_DOCUMENTS_ERROR',
  CLEAR_DOCUMENTS_SEARCH = 'CLEAR_DOCUMENTS_SEARCH',
  SEARCH_RECENT_DOCUMENTS = 'SEARCH_RECENT_DOCUMENTS',
  SEARCH_RECENT_DOCUMENTS_SUCCESS = 'SEARCH_RECENT_DOCUMENTS_SUCCESS',
  SEARCH_RECENT_DOCUMENTS_ERROR = 'SEARCH_RECENT_DOCUMENTS_ERROR',
  CLEAR_SEARCH_RECENT_DOCUMENTS = 'CLEAR_SEARCH_RECENT_DOCUMENTS',
  REGISTER_RECENT_DOCUMENTS_POLLING = 'REGISTER_RECENT_DOCUMENTS_POLLING',
  UNREGISTER_RECENT_DOCUMENTS_POLLING = 'UNREGISTER_RECENT_DOCUMENTS_POLLING',
}

// action payloads
export interface SearchGlobally {
  type: ActionsEnum.SEARCH_GLOBALLY;
  payload: ISearchDataPayload;
}

export interface SearchGloballySuccess {
  type: ActionsEnum.SEARCH_GLOBALLY_SUCCESS;
  payload: ISearchGloballyPayload;
}

export interface SearchGloballyError {
  type: ActionsEnum.SEARCH_GLOBALLY_ERROR;
  payload: ISearchDataErrorPayload;
}

export interface ClearGlobalSearch {
  type: ActionsEnum.CLEAR_GLOBAL_SEARCH;
}

export interface SearchDocuments {
  type: ActionsEnum.SEARCH_DOCUMENTS;
  payload: ISearchDataPayload;
}

export interface SearchDocumentsSuccess {
  type: ActionsEnum.SEARCH_DOCUMENTS_SUCCESS;
  payload: ISearchDocumentsPayload;
}

export interface SearchDocumentsError {
  type: ActionsEnum.SEARCH_DOCUMENTS_ERROR;
  payload: ISearchDataErrorPayload;
}

export interface ClearDocumentsSearch {
  type: ActionsEnum.CLEAR_DOCUMENTS_SEARCH;
}

export interface SearchRecentDocuments {
  type: ActionsEnum.SEARCH_RECENT_DOCUMENTS;
  payload: ISearchDataPayload;
}

export interface SearchRecentDocumentsSuccess {
  type: ActionsEnum.SEARCH_RECENT_DOCUMENTS_SUCCESS;
  payload: IRecentDocumentsPayload;
}

export interface SearchRecentDocumentsError {
  type: ActionsEnum.SEARCH_RECENT_DOCUMENTS_ERROR;
  payload: ISearchDataErrorPayload;
}

export interface ClearSearchRecentDocuments {
  type: ActionsEnum.CLEAR_SEARCH_RECENT_DOCUMENTS;
}

export interface RegisterRecentDocumentsPolling {
  type: ActionsEnum.REGISTER_RECENT_DOCUMENTS_POLLING;
  payload: IRegisterRecentDocumentsPolling;
}

export interface UnregisterRecentDocumentsPolling {
  type: ActionsEnum.UNREGISTER_RECENT_DOCUMENTS_POLLING;
}

// action creators
export const searchGlobally = (params: ISearchParams): SearchGlobally => ({
  type: ActionsEnum.SEARCH_GLOBALLY,
  payload: {
    params,
  },
});

export const searchGloballySuccess = (
  globalSearch: GlobalSearch
): SearchGloballySuccess => ({
  type: ActionsEnum.SEARCH_GLOBALLY_SUCCESS,
  payload: {
    globalSearch,
  },
});

export const searchGloballyError = (error: any[]): SearchGloballyError => ({
  type: ActionsEnum.SEARCH_GLOBALLY_ERROR,
  payload: {
    error,
  },
});

export const clearGlobalSearch = (): ClearGlobalSearch => ({
  type: ActionsEnum.CLEAR_GLOBAL_SEARCH,
});

export const searchDocuments = (params: ISearchParams): SearchDocuments => ({
  type: ActionsEnum.SEARCH_DOCUMENTS,
  payload: {
    params,
  },
});

export const searchDocumentsSuccess = (
  documentsSearch: DocumentsSearch
): SearchDocumentsSuccess => ({
  type: ActionsEnum.SEARCH_DOCUMENTS_SUCCESS,
  payload: {
    documentsSearch,
  },
});

export const searchDocumentsError = (error: any[]): SearchDocumentsError => ({
  type: ActionsEnum.SEARCH_DOCUMENTS_ERROR,
  payload: {
    error,
  },
});

export const clearDocumentsSearch = (): ClearDocumentsSearch => ({
  type: ActionsEnum.CLEAR_DOCUMENTS_SEARCH,
});

export const searchRecentDocuments = (
  params: ISearchParams
): SearchRecentDocuments => ({
  type: ActionsEnum.SEARCH_RECENT_DOCUMENTS,
  payload: {
    params,
  },
});

export const searchRecentDocumentsSuccess = (
  recentDocuments: RecentDocumentsSearch
): SearchRecentDocumentsSuccess => ({
  type: ActionsEnum.SEARCH_RECENT_DOCUMENTS_SUCCESS,
  payload: {
    recentDocuments,
  },
});

export const searchRecentDocumentsError = (
  error: any[]
): SearchRecentDocumentsError => ({
  type: ActionsEnum.SEARCH_RECENT_DOCUMENTS_ERROR,
  payload: {
    error,
  },
});

export const clearSearchRecentDocuments = (): ClearSearchRecentDocuments => ({
  type: ActionsEnum.CLEAR_SEARCH_RECENT_DOCUMENTS,
});

export const registerRecentDocumentsPolling = (
  pageSize: number,
  interval: number
): RegisterRecentDocumentsPolling => ({
  type: ActionsEnum.REGISTER_RECENT_DOCUMENTS_POLLING,
  payload: {
    pageSize,
    interval,
  },
});

export const unregisterRecentDocumentsPolling = (): UnregisterRecentDocumentsPolling => ({
  type: ActionsEnum.UNREGISTER_RECENT_DOCUMENTS_POLLING,
});
